import React from 'react';

const Badge = ({
  children,
  variant = 'primary',
  size = 'medium',
  className = ''
}) => {
  const baseStyles = 'inline-block font-medium rounded-full';

  const variants = {
    primary: 'bg-orange-500 text-white',
    secondary: 'bg-orange-100 text-orange-700',
    amber: 'bg-amber-100 text-amber-700',
    gray: 'bg-gray-100 text-gray-700',
    white: 'bg-white text-gray-700'
  };

  const sizes = {
    small: 'px-3 py-1 text-xs',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-2 text-base'
  };

  return (
    <span className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
